import { Heading, Stack, Box, ContentBlock } from 'braid-design-system';
import React from 'react';

import { TRACKING_CODES } from 'src/shared/constant';
import { TALENT_SEARCH, AD_CENTRE, AD_BUDGETS } from 'src/shared/links';

import PromosItem from './components/PromosItem';
import adBudgetImg from './img/adBudget.jpg';
import candidateManagementImg from './img/candidateManagement.jpg';
import talentSearchImg from './img/talentsearch.png';

const Promos = () => {
  const promosData = [
    {
      title: 'Manage candidates efficiently',
      subtext1:
        'Get access to our candidate management tools when you post Job Ads directly on the SEEK website or through your Recruitment Software Partner.',
      subtext2:
        'Pick the right candidate quickly with automated application sorting, fast filtering, skills matching and confirmed work credentials.',
      linkTitle: 'More about Candidate Management',
      href: AD_CENTRE,
      imgSrc: candidateManagementImg,
      isReverse: true,
      tracking: TRACKING_CODES.ad_center_link_clicked,
    },
    {
      title: 'Save money and stay flexible with Ad Budgets',
      subtext1: `If you've got more hiring on the horizon, a prepaid Ad Budget helps you stay flexible and save money.`,
      subtext2: `Allocate your budget to the Job Ad type that suits your needs, plus receive discounts on our Classic Ads.`,
      linkTitle: 'More about Ad Budgets',
      href: AD_BUDGETS,
      imgSrc: adBudgetImg,
      isReverse: false,
      tracking: TRACKING_CODES.ad_budgets_link_clicked,
    },
    {
      title: 'Boost your hiring with instant Candidate Matches',
      subtext1: `We automatically match relevant candidates with the rights skills and experience to your active job ads, helping you find the right fit faster.`,
      subtext2: `Enjoy up to 100 AI-matched candidate profiles with each job ad you post, extending your reach beyond current applicants.`,
      linkTitle: 'More about Talent Search',
      href: TALENT_SEARCH,
      imgSrc: talentSearchImg,
      isReverse: true,
      tracking: TRACKING_CODES.talent_search_link_clicked,
    },
  ];

  return (
    <ContentBlock>
      <Box
        marginTop={{ desktop: 'medium', mobile: 'large' }}
        marginBottom={{ desktop: 'xxlarge', mobile: 'xlarge' }}
      >
        <Stack space="xlarge">
          <Heading align="center" level="2">
            Get more value with every Job Ad
          </Heading>
          <Stack
            align="center"
            space={{ desktop: 'xxlarge', mobile: 'xlarge' }}
          >
            {promosData.map((data) => (
              <PromosItem key={data.title} {...data} />
            ))}
          </Stack>
        </Stack>
      </Box>
    </ContentBlock>
  );
};

export default Promos;
